export const howToMeasureInSizeGuide = 'how_to_measure_In_size_guide';
export const knowTheProductVariation = 'enable_know_the_product';
export const howToMeasureNewImagesVariation = 'how_to_measure_new_images';
export const displayRatingsLabelMsitePLP = 'rating-label-display-msite-plp';
